import { Alert, styled } from '@lingoda/ui';

export const BannerAlert = styled(Alert)(({ theme }) => ({
    width: '100%',
    padding: theme.spacing(2),
}));
